import { Tooltip } from "@material-ui/core";
import { IconButton } from '@mui/material';
import { ReactComponent as ExportIcon } from 'assets/icons/Export.svg';
import { ReactComponent as Share } from 'assets/icons/ShareClass.svg';
import { ReactComponent as WarningIcon } from 'assets/icons/WarningIcon.svg';

import Action from 'components/ActionPopOver';
import { formatDate } from "helper/dateFormat";
import { numberFormat } from "helper/numberFormat";
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import './FormDrawer.scss';
import {
  Button,
  Buttons,
  Contant,
  Dates,
  Description,
  Header,
  PreviewIcon,
  PriceSection, Total,
  Worning,
  Wrapper
} from './Theme';

const FormDrawer = ({
  drawerData,
  setIsDrawerOpen,
  setConfirmDialog,
  setArchiveStatus,
  setDeleteClassId,
  setArchiveClassId,
  onExport,
  setExportAllTable,
  exportAllTable,
  toggle,
}) => {
  const history = useHistory();
  const registrationEnds = drawerData?.alwaysAvailable ? 'Always available' : drawerData?.formEndDate ? formatDate({date:drawerData?.formEndDate, formatType: "defaultWithUTC"}) : '';
  const dates = [{title:"Registration Starts",
  content:formatDate({date:drawerData?.formStartDate, formatType: "defaultWithUTC"})},
                
  {title:"Registration ends",content:registrationEnds},

  {title:"Form",content:"Preview Form",icon:<PreviewIcon/>, onClick: () => {
    previewForm();
  }}]

  const organization = localStorage.getItem('organization')
    ? JSON.parse(localStorage.getItem('organization'))
    : null;
  const orgKey = organization?.orgkey;
  const mainUrl = window.location.origin;
  const checkDomain =
    mainUrl === 'https://admin.eztmpl.dev' ||
    mainUrl === 'http://localhost:3000'
      ? `https://shalom.eztmpl.dev/form/${drawerData?._id}`
      : mainUrl === 'https://admin.eztmpl.com'
      ? `https://demo.eztmpl.com/form/${drawerData?._id}`
      : mainUrl === 'https://admin.easyshul.com'
      ? `https://${orgKey}.easyshul.com/form/${drawerData?._id}`
      : null;

    const [copyLinkSuccess, setCopyLinkSuccess] = React.useState(false);

    useEffect(() => {
      const timer = setTimeout(() => {
        setCopyLinkSuccess(false);
      }, 2000);
      return () => clearTimeout(timer);
    }, [copyLinkSuccess]);

  const previewForm = () => {
    window.open(checkDomain, '_blank');
  };


const calculateProductPrice = (price) => {
  if(price?.type?.toLowerCase() === 'optional' && price?.variant) {
    const amounts = Object.values(price?.variantInfo).map(product => product.amount || 0);
    const minAmount = Math.min(...amounts);
    const maxAmount = Math.max(...amounts);
    return `${numberFormat({number:+minAmount || 0, decimal:2, style: 'currency'})} - ${numberFormat({number:+maxAmount || 0, decimal:2, style: 'currency'})}`
  } else {
    return `${numberFormat({number:+price?.amount || 0, decimal:2, style: 'currency'})}`
  }
}


  return (
    <Wrapper>
      <Contant>
        <Header>
        <span>{drawerData?.formName}</span>        
        <div className="popover__drawer">
          <IconButton className="p-0 px-2">
            <Action
              onEditClick={
                () =>history.push(`/edit-form/${drawerData?._id}`)
              }
              onArchiveClick={
                toggle
                  ? () => {
                      setArchiveClassId([drawerData?._id]);
                      setConfirmDialog(true);
                      setArchiveStatus(true);
                    }
                  : undefined
              }
              onClassDeleteClick={() => {
                setDeleteClassId(drawerData?._id);
                setConfirmDialog(true);
              }}
              style={{
                minHeight: "50px",
              }}
              action={'formDrawer'}
            />
          </IconButton>
        </div>
      </Header>
      <Dates>
        {dates.map((item)=>(
          <div 
            onClick={item?.onClick}
            style={{cursor:item?.title ==="Form" ? 'pointer':'default'}}
          >
          <span>{item.title}</span>
          <p>{item.content}{item?.icon}</p>
        </div>
        ))}
      
      </Dates>
  
      <Buttons>
          <Button onClick={()=>setExportAllTable(!exportAllTable)}><ExportIcon/><span>Export Form Data</span></Button>
          <Button
            onClick={() => {
              previewForm();
            }}
          ><Share/><span>Share Registration Link</span></Button>
      </Buttons>
      <Description>
        <span>Description</span>
        {drawerData?.description?.replace(/&lt;/g, '<') !== '<p></p>\n' && (
          <div className="drawer_description">
            <p
              dangerouslySetInnerHTML={{
                __html: drawerData?.description?.replace(/&lt;/g, '<'),
              }}
            ></p>
          </div>
        )}
      </Description>
      
  
      <Worning>
      <WarningIcon/><span>{drawerData?.allowNonMembers ? "Non" : "Only"} members are eligible to register for this Form</span>
      </Worning>
 
      
     
     <PriceSection>
     {drawerData?.formPricing?.prices?.length > 0 &&
      drawerData?.formPricing?.prices?.map((price) => (
        <div >
          <p style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            {price?.title}
            {price?.type?.toLowerCase() === 'optional' && <span className="price_section-optional">(Optional)</span>}
            {price?.isRecurring && (
              <Tooltip title="Monthly recurring" placement="top">
                <span className="recurring_indicator" style={{ display: 'inline-flex', alignItems: 'center', cursor: 'pointer', padding: '7px 9px', borderRadius: '6px' }}>
                  <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M4.5 0C2.02085 0 0 2.02085 0 4.5C0 6.9795 2.02085 9 4.5 9C6.76904 9 8.65385 7.308 8.95673 5.1165C8.96954 5.04742 8.96819 4.97646 8.95277 4.90791C8.93736 4.83937 8.90819 4.77466 8.86703 4.71772C8.82588 4.66078 8.7736 4.61278 8.71336 4.57663C8.65311 4.54048 8.58616 4.51693 8.51655 4.50741C8.44694 4.4979 8.37612 4.5026 8.30838 4.52125C8.24064 4.5399 8.1774 4.5721 8.12247 4.6159C8.06754 4.65971 8.02207 4.71421 7.98881 4.7761C7.95556 4.83798 7.93521 4.90598 7.929 4.97596C7.69604 6.66173 6.25535 7.96154 4.5 7.96154C2.58231 7.96154 1.03846 6.41804 1.03846 4.5C1.03846 2.58231 2.58231 1.03846 4.5 1.03846C5.62015 1.03846 6.61465 1.56981 7.24777 2.39054L6.63092 3.00738C6.579 3.05931 6.5655 3.14273 6.58765 3.21265C6.60842 3.28258 6.66692 3.32758 6.73927 3.34246C7.67285 3.52592 8.74938 3.44492 8.79438 3.43973C8.84 3.43151 8.88176 3.40881 8.91346 3.375C8.94462 3.34454 8.97231 3.31269 8.97854 3.26665C8.98373 3.22165 9.06508 2.13577 8.88092 1.20081C8.87544 1.166 8.8604 1.13339 8.83748 1.10663C8.81456 1.07986 8.78466 1.05998 8.75112 1.04919C8.6805 1.02773 8.59742 1.04054 8.54585 1.09246L7.98335 1.65496C7.15777 0.647308 5.90088 0 4.5 0Z" fill="#3C4467"/>
                    </svg>
                </span>
              </Tooltip>
            )}
          </p>
          <span>
            {calculateProductPrice(price)}
          </span>
        </div>
      ))}

   
     </PriceSection>

      </Contant>

    </Wrapper>
   
  );
};

export default FormDrawer;
